<template>
    <main class=" d-flex flex-column justify-content-center">
      <!-- <form @submit.prevent="submit"> -->
        <div class="d-flex flex-column align-items-center justify-content-center position-relative ">
            <section class="login_form d-flex flex-column align-items-center">
                <!-- <div class="login_form_img">
                    <img src="img/PDenvia.svg" class="card-img-top" alt="PDEnvia mail marketing">
                </div> -->
                <div >

                    <div class="card align-items-center shadow mb-2">                
                        <div
                            class="g-recaptcha"
                            data-sitekey="6LdLu68rAAAAAM-py7xGKr8jdms4zHM8lP9i7vHd"
                            data-callback="recaptchaOk"
                            ></div>
                    </div>

                    <div class="card align-items-center shadow mb-2"  v-if="isHuman">                
                        <div class="card-body  mb-2">
                            
                                    <div class="login_form_title d-flex flex-column justify-content-center text-secondary">
                                        <p class="h2 text-center">Login</p>
                                    </div>
                              
                                  <div class="login_forms flex-column justify-content-center">
                                      <input v-model= "dados.email" type="text" class="form-control"  placeholder="Usuario Dominio" name="email">
                                      <input v-model= "dados.password" type="password" class="form-control" placeholder="Senha" name="password">
                                  </div>
                                        
                                    
                                   
                                        <div class="d-flex flex-column align-items-center justify-content-center  ">
                                          
                                           <div><button type="button" class="btn bg-secondary btn-lg mb-2" @click="submit" >Entrar</button> </div>
       
                                        </div>         
                                      
                                        <p class="text-center text-danger" v-if="dados.error">      {{ dados.error }} </p>
                        </div>
         
                    </div>
                </div>
            </section>
        </div>
        <div class="login_footer d-flex flex-column justify-content-center d-none d-sm-block">
            <section class="login_footer_img d-flex flex-column align-items-center justify-content-sm-end mt-5">
                <!-- <img src="img/Pro_Saude_logo_white.svg" alt="Pro-Saúde" srcset=""> -->
            </section>
        </div>
        <!-- <div class="login_footer_text">
            <p class="h5 text-center mt-5 ">Powered by HRBA Labs</p>
        </div> -->

    <!-- </form> -->
  </main> 

</template>

<script>

import {computed,reactive,onMounted, ref} from "vue";
import {useRoute, useRouter} from "vue-router";
import {useStore} from "vuex";
import axios from 'axios';

import { useReCaptcha } from 'vue-recaptcha-v3'

export default {
    name: "Login",
    setup() {

        const store = useStore();
        const route = useRoute();

        const router = useRouter();
        
        const dados = reactive({
              email: '',
              password:'',
              username:'',
              foto:'',
              error:''
        });


        const isHuman = ref(false)

        // callback global que o Google chama
        window.recaptchaOk = () => {
        isHuman.value = true
        }


         onMounted(async () => {

            const script = document.createElement("script")
            script.src = "https://www.google.com/recaptcha/api.js"
            document.head.appendChild(script)

         });


        const getUser = async () => {
                    try {
                        const {data} = await axios.get('user');
                     //   console.log( data);
                        await store.dispatch('setUser', data);
                        
                        await router.push('/sistemas');
                        
                    } catch (e) {
                        await store.dispatch('setUser', null);
                    }


        }

        const submit = async () => {
            if (!isHuman.value) {
                dados.error = "Confirme que você não é um robô!";
                return;
            }

                await axios.post('login', {
                        email: dados.email,
                        password: dados.password
                }).then(response => {
                    
                        getUser();
                        console.log("conseguiu logar");
                    
                })
                .catch(error => {
                            //console.log( error.response.status);
                            //console.log( error.response.data.error);
                            dados.error =error.response.data.error;
                })
                .finally(() => 
                            setTimeout( () => {
                                dados.error = '';
                                }, 5000)
                );
      
  
        }

        return {
            dados,
            submit,
            isHuman,
            
        }

    }
}

</script>

